export const SET_TAKEAWAY_TABLE='SET_TAKEAWAY_TABLE'
export const SET_TAKEAWAY_TABLE_SUCCESS= 'SET_TAKEAWAY_TABLE_SUCCESS'
export const SET_TAKEAWAY_TABLE_ERROR= 'SET_TAKEAWAY_TABLE_ERROR'

export const SetTakeAwayTable= (data) => ({
    type: SET_TAKEAWAY_TABLE,
    payload: data
});